module.exports = __webpack_public_path__ + "static/img/rrrr_02.8317444.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_02.png
// module id = +6pM
// module chunks = 1